import Link from 'next/link';
import AGCLogo from '@/components/icons/AgcLogo';
import CloseButtonIcon from '@/components/icons/CloseButton';
import DeHaatLogoIcon from '@/components/icons/DeHaatLogo';
import { isAgricentralUser } from '@/utils/helper';
const Header = ({
  handleClose
}: {
  handleClose: VoidFunction;
}) => {
  const isFromAgricentral = isAgricentralUser();
  return <header className={`px-6 py-3 font-bold text-lg h-36 flex justify-between ${isFromAgricentral ? 'bg-white' : 'bg-primary-100'}`} data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <Link href="/" className="flex" aria-label="Home" data-sentry-element="Link" data-sentry-source-file="Header.tsx">
        {isFromAgricentral ? <AGCLogo className="fill-white m-auto" /> : <DeHaatLogoIcon className="fill-white w-40" />}
      </Link>
      <CloseButtonIcon data-testid="profile-header-close-button" className={`cursor-pointer mt-4 ${isFromAgricentral ? 'fill-neutral-90' : 'fill-white'}`} onClick={handleClose} role="button" aria-label="Close" height={32} width={32} data-sentry-element="CloseButtonIcon" data-sentry-source-file="Header.tsx" />
    </header>;
};
export default Header;